import { render, staticRenderFns } from "./MapSidePanel.vue?vue&type=template&id=89b423ba&scoped=true&"
import script from "./MapSidePanel.vue?vue&type=script&lang=js&"
export * from "./MapSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./MapSidePanel.vue?vue&type=style&index=0&id=89b423ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b423ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
